import * as React from 'react';
import { useMemo } from 'react';
import { DatePicker, Row, Select, Input } from 'antd';
import { Form } from '@ant-design/compatible';
import moment from 'moment-timezone';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { formatDateForLocationTimeZone } from '../../utils/DataFormatterUtils';

const FormItem = Form.Item;
export const DATE_FORMAT = 'MMMM D, YYYY h:mm a';

export const DateTimeWithTimeZone = ({
	form,
	location,
	rules,
	disabledDate = () => {},
	disabledTime = () => {},

	initialValue,
	timeZoneName,
	dateName,
	displayName,
	minuteStep = 1,
	initialTimeZone,
}) => {
	const { getFieldDecorator, getFieldValue } = form;

	const myTimeZone = moment.tz.guess();
	const locationTimeZone = nullSafeGet('timeZoneId', location);
	const myTimeZoneAbbreviation = moment.tz(new Date(), moment.tz.guess()).format('z');
	const localTimeZoneAbbreviation = moment.tz(new Date(), locationTimeZone).format('z');

	const selectedTimeZone = getFieldValue(timeZoneName) || locationTimeZone || myTimeZone;
	const selectedTimeZoneAbbreviation = useMemo(
		() => moment.tz(selectedTimeZone).format('z'),
		[selectedTimeZone]
	);

	const showNow = selectedTimeZone === myTimeZone;

	const initialValueAdjustedForInitialTimeZone = useMemo(() => {
		return initialValue && (initialTimeZone || locationTimeZone)
			? moment.utc(initialValue).tz(initialTimeZone || locationTimeZone)
			: undefined;
	}, [initialValue, initialTimeZone, locationTimeZone]);

	return (
		<>
			<Row className={'flex justify-between align-baseline'} align="middle">
				<span style={{ paddingBottom: myTimeZone === locationTimeZone ? 8 : 0 }}>
					{displayName}
				</span>
				<Form.Item style={{ marginBottom: 0, paddingBottom: 0 }}>
					{getFieldDecorator(timeZoneName, {
						initialValue: initialTimeZone || locationTimeZone || myTimeZone,
					})(
						<Select
							style={{ marginLeft: 8, flex: 0, minWidth: 175 }}
							bordered={false}
							align="right"
							disabled={myTimeZone === locationTimeZone}
						>
							<Select.Option value={myTimeZone}>My Time ({myTimeZoneAbbreviation})</Select.Option>
							<Select.Option value={locationTimeZone}>
								Location Time ({localTimeZoneAbbreviation})
							</Select.Option>
						</Select>
					)}
				</Form.Item>
			</Row>

			<FormItem>
				<Input.Group compact style={{ display: 'flex' }}>
					{getFieldDecorator(dateName, {
						rules: rules,
						initialValue:
							initialValueAdjustedForInitialTimeZone || moment().tz(locationTimeZone || myTimeZone),
					})(
						<DatePicker
							disabledDate={disabledDate}
							disabledTime={disabledTime}
							style={{ width: '100%' }}
							showTime={{ minuteStep }}
							format={DATE_FORMAT}
							showNow={showNow}
						/>
					)}
					<span
						style={{
							display: 'inline-flex',
							alignItems: 'center',
							padding: '0 10px',
							background: '#fafafa',
							border: '1px solid #d9d9d9',
							borderLeft: 0,
							borderRadius: '0 2px 2px 0',
							whiteSpace: 'nowrap',
						}}
					>
						{selectedTimeZoneAbbreviation}
					</span>
				</Input.Group>
			</FormItem>
		</>
	);
};
